module.exports = __webpack_public_path__ + "img/live-img.b1a59ed9.jpg";